<template>
  <AuthLayout title="Email verification">
    <ParagraphText class="mb-4"
      >Thanks for signing up! Before getting started, could you verify your
      email address by clicking on the link we just emailed to you? If you
      didn't receive the email, we will gladly send you another.</ParagraphText
    >

    <ParagraphText
      font="font-medium"
      color="text-green-600"
      class="mb-4"
      v-if="verificationLinkSent"
    >
      A new verification link has been sent to the email address you provided
      during registration.
    </ParagraphText>

    <form @submit.prevent="submit">
      <div class="mt-4 flex items-center justify-between">
        <ButtonBase type="submit" :processing="form.processing"
          >Resend Verification Email</ButtonBase
        >

        <LinkBase
          class="text-sm"
          method="post"
          as="button"
          :href="route('logout')"
          >Log Out</LinkBase
        >
      </div>
    </form>
  </AuthLayout>
</template>

<script setup>
import { computed } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

import AuthLayout from '@/Layouts/AuthLayout.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import LinkBase from '@/Common/Text/LinkBase.vue'

const props = defineProps({
  status: String,
})

const form = useForm()

function submit() {
  form.post(route('verification.send'))
}

const verificationLinkSent = computed(
  () => props.status === 'verification-link-sent'
)
</script>
